<template>
  <div class="app-container">
    <div class="menu-tab top-screen">
      <div class="item" :class="type == 1 ? 'active' : ''" @click="changeActive(1)">PC端</div>
      <div class="item" :class="type == 2 ? 'active' : ''" @click="changeActive(2)">小程序</div>
    </div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      :authIdentity="authIdentity"
    ></SearchComponent>

    <!-- <SearchComponent
      ref="MSearch"
      :isAdd="true"
      :isTime="false"
      :is-export="true"
      @on-export="handleExport"
      :selectList="selectList"
      :inputList="inputList"
      @on-add="handleAdd"
      @on-search="handleQuery"
      @on-reset="resetQuery"
      authIdentity="system:menu"
    ></SearchComponent>-->

    <div class="onOneLine3">
      <el-table
        class="listTable"
        :data="list"
        border
        row-key="id"
        :max-height="680"
        ref="containTable"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="名称" prop="menuName" :show-overflow-tooltip="true" />
        <el-table-column label="icon" prop="icon" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <svg-icon :icon-class="scope.row.icon" />
          </template>
        </el-table-column>
        <el-table-column label="路由地址" prop="path" :show-overflow-tooltip="true" />
        <el-table-column label="组件路径" prop="component" :show-overflow-tooltip="true" />
        <el-table-column label="类型" prop="menuType" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span
              :style="[
              {
                color: scope.row.menuType == 'M' ? 'grey' : scope.row.menuType == 'C' ? 'green' : 'blue',
              },
            ]"
            >{{ formatter.menuType[scope.row.menuType] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 0 ? 'normal' : scope.row.status == 1 ? 'disable' : ''"
            >{{ formatter.status[scope.row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div class="operation">
              <el-button type="text" @click="handleAdd(scope.row)">新增</el-button>
              <el-button type="text" @click="handleUpdate(scope.row)">修改</el-button>
              <el-button class="delbutton" type="text" @click="handleDelete(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加或修改菜单对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="700px"
      append-to-body
      :fullscreen="mFullscreen"
      :before-close="cancel"
      :show-close="false"
      :top="'5vh'"
    >
      <div slot="title">
        <DialogHead :title="title" :mFullscreen.sync="mFullscreen" @cancel="cancel"></DialogHead>
      </div>
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">菜单信息</div>
        </div>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="auto">
        <el-form-item label="父级菜单">
          <treeselect
            :options="TreeselectList"
            :normalizer="normalizer"
            placeholder="请选择所属父级菜单"
            v-model="form.parentId"
          />
        </el-form-item>
        <el-form-item label="名称" prop="menuName">
          <el-input placeholder="请输入菜单名称" v-model="form.menuName"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" prop="path">
          <el-input placeholder="请输入路由地址" v-model="form.path"></el-input>
        </el-form-item>
        <el-form-item label="组件路径" prop="component">
          <el-input placeholder="请输入组件路径" v-model="form.component"></el-input>
        </el-form-item>
        <el-form-item v-if="form.menuType=='F'" label="按钮权限" prop="perms">
          <el-input placeholder="请输入按钮权限" v-model="form.perms"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="14">
            <el-form-item label="类型" prop="menuType">
              <el-radio-group v-model="form.menuType">
                <el-radio label="M">目录</el-radio>
                <el-radio label="C">菜单</el-radio>
                <el-radio label="F">按钮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="icon">
              <el-popover placement="bottom-start" width="600" @show="$refs['iconSelect'].reset()">
                <IconSelect ref="iconSelect" @selected="selected" />
                <el-input slot="reference" v-model="form.icon" placeholder="点击选择图标">
                  <svg-icon :icon-class="form.icon" />
                </el-input>
              </el-popover>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="排序">
              <el-input-number v-model="form.sort" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否外链" prop="isFrame">
              <el-radio-group v-model="form.isFrame">
                <el-radio label="0">外链</el-radio>
                <el-radio label="1">无外链</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否缓存" prop="isCache">
              <el-radio-group v-model="form.isCache">
                <el-radio label="1">不缓存</el-radio>
                <el-radio label="0">缓存</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否显示" prop="visible">
              <el-radio-group v-model="form.visible">
                <el-radio :label="0">显示</el-radio>
                <el-radio :label="1">隐藏</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="0">正常</el-radio>
                <el-radio :label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="300字以内" :maxlength="300" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import MSearch from '@/components/Select/searchComponent.vue'
import DialogHead from '@/components/innerDialogHead.vue'
import SearchComponent from '@/components/searchComponent'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import IconSelect from '@/components/IconSelect'
import { saveMenu, getmenuList, updateMenu, deleteMenuData } from '@/api/system/system'
// import {
//   getList,
//   getListById,
//   getTreeselect,
//   add,
//   put,
//   del,
// } from '@/api/system/menu'
// import Mixins from '@/mixins'
export default {
  name: 'Serve',
  components: { DialogHead, Treeselect, IconSelect, SearchComponent },
  data() {
    return {
      authIdentity: 'system:menu',
      mFullscreen: false,
      tableLoading: true,
      //  menuName:'名称' ,icon:icon,path:路由地址,component:组件路径,menuType:类型,status:状态
      colLists: [
        { label: '名称', prop: 'menuName' },
        { label: 'icon', prop: 'icon' },
        { label: '路由地址', prop: 'path' },
        { label: '组件路径', prop: 'component' },
        { label: '名称', prop: 'menuName' },
      ],
      selectOrInputList: [
        {
          model: 'status',
          placeholder: '状态',
          value: 'value',
          label: 'label',
          list: [
            { label: '正常', value: '0' },
            { label: '停用', value: '1' },
          ],
          type: 'select',
        },
        {
          model: 'menuName',
          placeholder: '请输入菜单名称',
          class: 'home',
          type: 'input',
        },
      ],
      filename: '菜单管理',
      type: 1, //0pc, 1移动端

      // selectList: [
      //   {
      //     model: 'status',
      //     placeholder: '请选择状态',
      //     value: 'value',
      //     label: 'text',
      //     list: [
      //       { text: '正常', value: '0' },
      //       { text: '停用', value: '1' },
      //     ],
      //   },
      // ],
      // inputList: [
      //   {
      //     model: 'menuName',
      //     placeholder: '请输入菜单名称',
      //   },
      // ],
      // 遮罩层
      loading: true,
      treeExpand: false, // 展开/折叠
      treeNodeAll: false, // 全选/全不选
      treeConnect: true, // 父子联动
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 菜单表格数据
      list: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        menuName: null,
        status: null,
      },
      // 表单参数
      form: {
        menuId: null,
        icon: null,
        isCache: '1',
        isFrame: '1',
        menuName: null,
        menuType: null,
        component: null,
        // orderNum: null,
        perms: '',
        parentId: null,
        path: null,
        type: this.type,
        status: 0,
        visible: 0,
        remark: null,
      },
      menuOptions: [], // 菜单列表
      TreeselectList: [],
      formatter: {
        menuType: { M: '目录', C: '菜单', F: '按钮' },
        isFrame: { 0: '外链', 1: '无外链' },
        isCache: { 0: '缓存', 1: '不缓存' },
        status: { 0: '正常', 1: '停用' },
      },
      filters: {
        status: [
          { text: '正常', value: '0' },
          { text: '停用', value: '1' },
        ],
      },
      // 表单校验
      rules: {
        // serveName: [
        //   { required: true, message: "服务名称不能为空", trigger: "blur" },
        // ],
        menuName: [{ required: true, message: '菜单名称不能为空', trigger: 'blur' }],
        menuType: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        path: [{ required: true, message: '路由地址不能为空', trigger: 'blur' }],
      },

      /** 新增或修改弹窗 */
      activeName: 'active',
      // type: "",
      // open: false,
    }
  },
  created() {
    this.getmenuList()
  },
  methods: {
    changeActive(type) {
      this.type = type
      this.getmenuList()
      // this.$refs.MSearch.handelReset()
      // this.resetQuery()
    },
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.menuName,
        children: node.children,
      }
    },
    // 表单重置
    reset() {
      this.form = {
        menuId: null,
        icon: null,
        isCache: '1',
        isFrame: '1',
        menuName: null,
        menuType: null,
        component: null,
        // orderNum: null,
        perms: '',
        parentId: null,
        path: null,
        type: this.type,
        status: 0,
        visible: 0,
        remark: null,
      }
      // this.resetForm('form')
    },
    handleReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        menuName: null,
        status: null,
      }
      this.getmenuList()
    },
    cancel() {
      this.reset()
      this.open = false
    },
    handleAdd(row) {
      this.reset()
      // this.getTreeselectAll()
      this.open = true
      if (row) {
        console.log(row, 'row0000000000000000000000')
        this.form.parentId = row.id
        this.form.sort = row.children ? row.children.length + 1 : 0
      }

      this.title = '新增'
    },
    handleUpdate(row) {
      console.log(row, 'row-------------------------------')

      if (row) {
        this.form.parentId = row.parentId
        this.form.id = row.id
        this.form.sort = row.sort
        this.form.menuName = row.menuName
        this.form.path = row.path
        this.form.component = row.component
        this.form.menuType = row.menuType
        this.form.icon = row.icon
        this.form.sort = row.sort
        this.form.status = row.status
        this.form.type = row.type
        this.form.remark = row.remark
        this.form.isCache = row.isCache
        this.form.isFrame = row.isFrame
        this.form.visible = row.visible
        this.form.perms = row.perms
      }
      this.open = true
      this.title = '修改'
    },
    selected(name) {
      this.form.icon = name
    },
    handleSearch(data) {
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }
      this.getmenuList()
    },
    handleDelete(row) {
      let ids = row.id
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return deleteMenuData(ids)
        })
        .then((res) => {
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.getmenuList()
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    getmenuList() {
      getmenuList(this.queryParams)
        .then((res) => {
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.list = this.handleTree(
              res.data.filter((item) => item.type == this.type),
              'id'
            )
            console.log(this.type, 'this.type----------------')
            this.TreeselectList = this.handleTree(
              res.data.filter((item) => item.type == this.type),
              'id'
            )
            this.TreeselectList.unshift({ id: 0, menuName: '主类目' })
            console.log(this.TreeselectList, 'this.TreeselectList')
            // this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
            // this.refreshCode()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submitForm() {
      console.log('点击ij·----------------')

      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.title == '新增') {
            saveMenu(this.form)
              .then((res) => {
                if (res.flag) {
                  this.$message.success(res.message)
                  this.reset()
                  this.getmenuList()
                  this.open = false
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                console.log(error)
              })
          } else {
            updateMenu(this.form)
              .then((res) => {
                if (res.flag) {
                  this.$message.success(res.message)
                  this.reset()
                  this.getmenuList()
                  this.open = false
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import '~@/assets/form.less';
@import '~@/assets/style/innerDialog.less';
/deep/ .delbutton.el-button--text {
  color: red;
}
.disable {
  color: red;
}
.normal {
  color: green;
}
::v-deep {
  .listTable {
    border: 2px solid #ebeffa;
    // border-top-right-radius: 16px;
    // border-top-left-radius: 16px;
    // border-bottom-width: 1px;
    border-radius: 16px;

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }
  }
  .el-table__footer-wrapper {
    margin-top: 0px;
  }
  .el-table__cell {
    border-right: none;
  }
  .el-table__header-wrapper {
    border-radius: 16px 16px 0px 0px;
  }
  .el-table th.el-table__cell {
    background: #ece4ce;
    color: #282c38;
    font-size: 14px;
    .cell {
      border-right: 1px solid #cfcff4;
    }
  }
  .el-table .el-table__cell {
    text-align: left;
  }
  // 分页
  .pagination {
    //padding-right: 60px;
    height: 44px;
    // position: fixed;
    right: 15px;
    bottom: 20px;
    .el-pagination {
      display: -moz-box;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flexbox;
      display: flex;

      -webkit-box-pack: right;
      -ms-justify-content: right;
      -moz-justify-content: right;
      -o-justify-content: right;
      -webkit-justify-content: right;
      justify-content: right;

      -webkit-box-align: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -webkit-align-items: center;
      align-items: center;

      height: 100%;
      padding: 0;
    }

    // 上一页
    .btn-prev,
    .btn-next {
      width: 100px;
      height: 100%;
      border-radius: 12px;

      .el-icon {
        text-align: center;
        margin: auto;
        font-size: 14px;

        &::before {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '<';
          color: #d3d6e4;
        }

        &::after {
          content: '上一页';
          color: #ffffff;
          margin-left: 5px;
        }
      }
    }

    .btn-prev {
      background-color: #b7b7b7;

      .el-icon {
        &::before {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '<';
          color: #d3d6e4;
        }

        &::after {
          content: '上一页';
          color: #ffffff;
          margin-left: 5px;
        }
      }
    }

    .btn-next {
      background-color: #c59429;

      .el-icon {
        &::after {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '>';
          color: #d3d6e4;
        }

        &::before {
          content: '下一页';
          color: #ffffff;
          margin-right: 5px;
          font-size: 14px;
        }
      }
    }

    .el-pager {
      display: flex;
      align-items: center;
      height: 100%;
      background-color: #e3e4eb;
      border-radius: 12px;

      .number {
        width: 40px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        background-color: #e3e4eb;
      }

      .active {
        background-color: #ffffffeb !important;
        border-radius: 12px;
        color: black !important;
      }
    }
  }
}
.app-container {
  font-size: 14px;
}
.menu-tab {
  display: flex;
  align-content: center;
  padding: 8px;
  background: #ebeffa;
  border-radius: 8px;
  margin-bottom: 20px;
  .item {
    padding: 4px 12px;
    margin-right: 10px;
    font-size: 14px;
    color: #757b8c;
    border-radius: 8px;
    cursor: pointer;
  }
  .active {
    font-size: 16px;
    font-weight: 500;
    background: #fff;
  }
}
</style>
